import { eNavSubMode } from "../../../model/common/eNavSubMode";
import { eThemeMode } from "../../../model/common/eThemeMode";
import { ILayouActions } from "../../action-types/common/ILayouActions";
import { ILayoutReducer } from "../../reducer-model/common/ILayoutReducer";
const iniState: ILayoutReducer = {
  themeMode: eThemeMode.light,
  navSubMode: window.innerWidth >= 1400 ? eNavSubMode.FULL : eNavSubMode.POPUP,
  hoc_ky: parseInt(localStorage.getItem("hoc_ky") ?? "1") ?? 1,
  nam_hoc:
    localStorage.getItem("nam_hoc") ??
    `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`,
  nam_nhap_hoc:
    Number(localStorage.getItem("nam_nhap_hoc")) || new Date().getFullYear(),
};
export const layoutReducer = (
  state: ILayoutReducer = iniState,
  action: ILayouActions
): ILayoutReducer => {
  switch (action.type) {
    case "LAYOUT_CHANGE_THEME_MODE":
      return {
        ...state,
        themeMode: action.payload,
      };
    case "LAYOUT_CHANGE_NAV_MODE":
      return {
        ...state,
        navSubMode: action.payload,
      };
    case "LAYOUT_CHANGE_MODULE_SELECTED":
      return {
        ...state,
        moduleSelected: action.payload,
      };
    case "LAYOUT_CHANGE_HOC_KY":
      localStorage.setItem("hoc_ky", action.payload.toString());
      return {
        ...state,
        hoc_ky: action.payload,
      };
    case "LAYOUT_CHANGE_NAM_NHAP_HOC":
      localStorage.setItem("nam_nhap_hoc", action.payload.toString());
      localStorage.setItem(
        "nam_hoc",
        `${action.payload}-${action.payload + 1}`
      );
      return {
        ...state,
        nam_nhap_hoc: action.payload,
        nam_hoc: `${action.payload}-${action.payload + 1}`,
      };
    case "LAYOUT_CHANGE_NAM_HOC":
      localStorage.setItem("nam_hoc", action.payload.toString());
      localStorage.setItem("nam_nhap_hoc", action.payload.split("-")[0]);
      return {
        ...state,
        nam_hoc: action.payload,
        nam_nhap_hoc: +action.payload.split("-")[0],
      };
    default:
      return state;
  }
};
